<template>
  <section v-if="tag" v-qa="`ds_warning_section`" class="warning">
    <div v-html="translationTag"/>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'WarningSection',
  computed: {
    ...mapGetters('debt-sold', ['tag', 'translationTag']),
  },
};
</script>

<style scoped lang="scss">
.warning {
  border: 1px solid map_get($colors, border);
  border-radius: 10px;
  background: map-get($colors, info);
  padding: 20px;
  margin-bottom: 20px;
}
</style>
